import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
    StringCustomFieldConfig,
    SharedModule,
    FormInputComponent,
    DataService,
} from '@vendure/admin-ui/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import gql from 'graphql-tag';

const GET_DECRYPTED_DOB_QUERY = gql`
    query GetCustomerDob($id: ID!) {
        customer(id: $id) {
            id
            actualDob
        }
    }
`;

interface GetCustomerDobResponse {
    customer: {
        id: string;
        actualDob: string;
    } | null;
}

@Component({
    template: `
        <input class="form-control" type="date" [value]="decryptedDob$ | async" disabled />
    `,
    standalone: true,
    imports: [SharedModule],
})
export class DobFormComponent implements OnInit, FormInputComponent<StringCustomFieldConfig> {
    readonly: boolean;
    config: StringCustomFieldConfig;
    formControl: FormControl;

    decryptedDob$: Observable<string>;

    constructor(
        private dataService: DataService,
        private route: ActivatedRoute,
    ) {}

    ngOnInit() {
        const customerId = this.route.snapshot.paramMap.get('id');

        if (customerId) {
            this.decryptedDob$ = this.dataService
                .query<GetCustomerDobResponse>(GET_DECRYPTED_DOB_QUERY, { id: customerId })
                .mapSingle(({ customer }) => customer?.actualDob || '');
        } else {
            this.decryptedDob$ = of('');
        }
    }
}
